import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface RegtankLivenessWebVerifyData {
  token: string;
  sessionId: string;
}

const getRegtankLivenessWebVerifyStatus = async ({
  token,
  sessionId,
}: RegtankLivenessWebVerifyData) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/regtank-liveness-web-verify-status/${sessionId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    (error as Error).message = message;
    throw error;
  }
};

export default getRegtankLivenessWebVerifyStatus;
